export default "<router-outlet></router-outlet>\r\n<app-toast></app-toast>\r\n";